import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.documentElement.setAttribute('data-theme', savedTheme);
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobileViewport = width <= 768;
      setIsMobile(mobileViewport);

      if (width > 768 && width <= 1024) {
        setIsSidebarCollapsed(true);
      } else if (width > 1024) {
        setIsSidebarCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <div className={`layout ${isMobile ? 'mobile' : 'desktop'}`}>
      <Sidebar
        isOpen={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
        isMobile={isMobile}
        isCollapsed={isSidebarCollapsed && !isMobile}
        onToggleCollapse={handleSidebarToggle}
      />

      <div className="main-content">
        <main className="content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
